const getters = {
  token: state => state.user.token,
  realName: state => state.user.realName,
  duty: state => state.user.duty,
  headPortrait: state => state.user.headPortrait,
  nowUserId: state => state.user.nowUserId,
  nowRealName: state => state.user.nowRealName,
  nowDuty: state => state.user.nowDuty,
  nowCompanyId: state => state.user.nowCompanyId,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js